import SimpleDropdown from "./SimpleDropdown";

const dropdowns = {
    SimpleDropdown,
}

export default dropdowns;